import { Box, Heading, Flex } from "@chakra-ui/react";
import { useState } from "react";
import { Button } from "../button";
import { useDownloadFile } from "../../shared-logic/useDownloadFile";

function getConversionTypeByFileName(fileName: string): "html" | undefined {
  if (fileName.endsWith(".hl7")) return undefined;
  return "html";
}

// add to this list when creating a new section that no longer needs the "Show Source"
// ex: vitals has per-data-point downloads now, "Show Source" button is no longer needed
const hideShowSourceSections = ["Lab", "Blood Pressure", "Vital", "Suspect Condition"];

export function SidePanelContent({
  title,
  sourceDocument,
  fhirJson,
  children,
}: {
  title: string;
  sourceDocument: {
    id: string;
    fileName: string;
  };
  fhirJson?: string;
  children: React.ReactNode;
}) {
  const { isDownloading, onDownloadFile } = useDownloadFile();
  const [stateJson, setJson] = useState<string | undefined>(undefined);
  const showDownloadSourceButton = !hideShowSourceSections.includes(title);

  return (
    <Box>
      <Flex justifyContent={"space-between"}>
        <Heading mb="3">{title}</Heading>
        <Box>
          {showDownloadSourceButton && (
            <Button
              isLoading={isDownloading[sourceDocument.id]?.downloading ?? false}
              onClick={() => {
                if (!sourceDocument.id || !sourceDocument.fileName) return;

                onDownloadFile({
                  docId: sourceDocument.id,
                  docFilename: sourceDocument.fileName,
                  conversionType: getConversionTypeByFileName(sourceDocument.fileName),
                });
              }}
            >
              View Source
            </Button>
          )}

          {fhirJson && (
            <Button
              ml={2}
              isLoading={isDownloading[sourceDocument.id]?.downloading ?? false}
              onClick={() => {
                setJson(stateJson ? undefined : fhirJson);
              }}
            >
              {stateJson ? "X" : JSON.stringify({})}
            </Button>
          )}
        </Box>
      </Flex>

      {stateJson ? <pre style={{ whiteSpace: "pre-wrap" }}>{stateJson}</pre> : children}
    </Box>
  );
}
